import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect,
} from 'vue-search-select';
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect';
import apiUrl from '../../../constants';
import awsBucketName from '../../../constants';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import moment from 'moment'
import {fetchExternalDisputeReasons} from '../../../services/externalDispute';


export default {
  name: 'markRTOInvestigation',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect,
  },
  data() {
    return {
      forwarddispute: '',
      current_region_name: '',
      origin_hub_name: '',
      destination_hub_name: '',
      current_hub_name: '',
      octroi_MRP: '',
      client_name: '',
      description: '',
      image: '',
      product_desc: '',
      sub_status: '',
      laststatus: '',
      lastshipmentstatus: '',
      // for status list
      Status: '',
      StatusList: [],
      myStr: '',
      // lodar
      show: false,

      // for substatus
      SubStatus: '',
      subStatusList: [],

      //
      dropSubStatus: '',
      reasonsIsOption:false,
      dropStatus: '',

      // shipment arr
      shipmenarr: '',
      newhubList: [],
      zoneid: 0,
      newzoneList: [],
      clienList: [],

      // images
      imagesarr: [],
      attachment: null,
      displaytable: false,
      // try
      path: `${awsBucketName}/1234/wallpaperflare.com_wallpaper-1.jpg`,
      //   fname1: 'download.jpeg',
      fname1: 'wallpaperflare.com_wallpaper-1.jpg',
      imgdata: '',
      showModal: false,
      imgData: '',
      awbnumber: '',
      abc: '',
      DisputeType: '',
      username: '',
      Uploadimage: '',
      disputstatus: '',
      FileSelected: null,
      Searchdisable: '',
      statusIsOption:true,
      reasons:'',
      subReasons:'',
      reasonsList:[],
      subReasonsList:[],
      index:'',
      selectedFile: null,
      videosArr: [],
      allowedExtensions: ["mp4", "mpeg", "avi", "mov"],
      maxSizeBytes: 20 * 1024 * 1024, // 20 MB
      searchLoading : false,
      isUploading : false,
      isVideoUploading : false,
      disputemarkedonhubid : null,
      disputemarkedonhubname : '',
      isimage : true,
      isvideo : true,
      islastbagoutavailable : false
    };
  },
  mounted() {
    const userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.username = window.localStorage.getItem('username');
    this.status();
    this.subStatus();

  },
  computed: {
    SearchDisableds: function () {
      return (this.Searchdisable == '') ? false : true;
    },
  },
  methods: {
    fetchDisputeReasons(reasonName){
      let input = {
        taskType : "DTODispute",
        disputeRaisedType : "XB"
      }
      fetchExternalDisputeReasons(input, this.myStr).then(reasons => {
        let resonData = reasons.data.ReturnResult;
        if(reasonName!==undefined){
          let reasonsData = resonData.find(person => person.reason === reasonName.label);
          this.subReasonsList = reasonsData.subReason.map((subreasons) => ({id:subreasons.disputereasonid, label: subreasons.subReason}));
        }
        this.reasonsList = resonData.map((reasons, i) => ({id: i, label: reasons.reason}));
      });
    },

    status() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}rtoDisputeStatus`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const statusdata = [];
        result.data.data.forEach((status) => {
          statusdata.push({
            id: status.pickupstatuscode,
            label: status.pickupstatusname,
          });
        });
        this.StatusList = statusdata;

      },
        (error) => {
          console.error(error);
        });
    },
    subStatus() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}rtoDisputeSubStatus`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const substatusdata = [];
        result.data.data.forEach((sub) => {
          substatusdata.push({
            id: sub.pickupstatuscode,
            label: sub.pickupstatusname,
          });
        });
        this.subStatusList = substatusdata;
      },
        (error) => {
          console.error(error);
        });
    },

    // zone api
    getZoneFromcurrenthub(zonehubid) {
      this.show = true;
      const zonehubarr = [];
      zonehubarr.push(zonehubid);
      this.input = ({
        hubids: zonehubarr,
      });
      axios({
        method: 'post',
        url: `${apiUrl.api_url}gethubzoneIdsbyhubId`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },

      }).then((result) => {
        this.zoneid = result.data.data;
        this.getzone();
        // this.gethubList(this.zoneid);
        // this.getClientList();

      },
        (error) => {
          this.show = false;
          console.error(error);
        });
    },

    getClientList() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getClientList`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },

      }).then((result) => {
        this.clienList = result.data.data;
        for (let j = 0; j < this.clienList.length; j++) {
          if (this.clienList[j].ClientMasterID == this.shipmenarr.ClientID) {
            this.client_name = this.clienList[j].CompanyName;
          }
        }
      },
        (error) => {
          this.show = false;
          console.error(error);
        });
    },

    getzone() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getZoneList`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },

      }).then((result) => {
        const finalHubData = [];
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.hubzoneid,
            label: hub.hubzonename,
          });
        });
        this.newzoneList = finalHubData;
        for (let i = 0; i < this.newzoneList.length; i++) {
          if (this.zoneid == this.newzoneList[i].id) {
            this.current_region_name = this.newzoneList[i].label;
          }
        }
      },
        (error) => {
          console.error(error);
        });
    },

    // hub  api
    // gethubList(zoneid) {
    //   this.input = ({
    //     id: zoneid,
    //   });
    //   axios({
    //     method: 'post',
    //     url: `${apiUrl.api_url}getHubList`,
    //     data: { id: this.zoneid },
    //     headers: {
    //       Authorization: `Bearer ${this.myStr}`,
    //     },

    //   }).then((result) => {
    //     this.show = false;
    //     const finalHubData = [];
    //     result.data.data.forEach((hub) => {
    //       finalHubData.push({
    //         id: hub.HubID,
    //         label: hub.HubName,
    //       });
    //     });
    //     this.newhubList = finalHubData;
    //     for (let j = 0; j < this.newhubList.length; j++) {
    //       if (this.newhubList[j].id == this.shipmenarr.CurrentHubID) {
    //         this.current_hub_name = this.newhubList[j].label;
    //       }
    //     }
    //     for (let k = 0; k < this.newhubList.length; k++) {
    //       if (this.newhubList[k].id == this.shipmenarr.OriginHubID) {
    //         this.origin_hub_name = this.newhubList[k].label;
    //       }
    //     }
    //     for (let z = 0; z < this.newhubList.length; z++) {
    //       if (this.newhubList[z].id == this.shipmenarr.FinalDestinationID) {
    //         this.destination_hub_name = this.newhubList[z].label;
    //       }
    //     }
    //   },
    //     (error) => {
    //       this.show = false;
    //       console.error(error);
    //     });
    // },

    selectData() {
      this.statusIsOption=true
      this.reasonsIsOption=false
      this.forwarddispute = this.disputstatus;
      if (this.forwarddispute.toLowerCase() == "forwarddispute") {
        this.DisputeType = "ForwardDispute"
      } else if (this.forwarddispute.toLowerCase() == "rtodispute") {
        this.DisputeType = "RTODispute"
      }
      else if (this.forwarddispute.toLowerCase() == "dtodispute") {
        this.statusIsOption=false
        this.reasonsIsOption=true
        this.DisputeType = "DTODispute"
        this.fetchDisputeReasons();
      }
    },

    getShipmentDetailsByShippingId() {
      this.searchLoading = true
      this.input = ({
        ShippingId: this.awbnumber

      });
      if (!this.awbnumber) {
        this.$alertify.error("Please Select Shippingid");

      }
        axios({
          method: 'post',
          url: `${apiUrl.api_url}getShipmentDetailsByShippingId`,
          data: this.input,
          headers: {
            Authorization: `Bearer ${this.myStr}`,
          },
        }).then((result) => {
          if (result.data.code == 200) {
            this.shipmenarr = result.data.data;
            const zonehubid = this.shipmenarr["CurrentHubID"];
            // this.getZoneFromcurrenthub(zonehubid);

            this.octroi_MRP = this.shipmenarr["NetValue"];
            this.product_desc = this.shipmenarr["Contents"];
            this.Status = this.shipmenarr["Status"];
            this.SubStatus = this.shipmenarr["ShipmentStatus"];
            this.lastshipmentstatus = this.shipmenarr["LastShipmentStatus"];
            this.laststatus = this.shipmenarr["LastStatus"];

            this.awbnumber = this.shipmenarr["ShippingID"];
          this.disputstatus = this.shipmenarr["disputetype"];
          this.disputemarkedonhubid = this.shipmenarr["disputemarkedonhubid"];
          this.disputemarkedonhubname = this.shipmenarr["disputemarkedonhubname"];
          this.origin_hub_name = this.shipmenarr["OriginHubName"];
          this.current_hub_name = this.shipmenarr["CurrentHubName"];
          this.destination_hub_name = this.shipmenarr["FinalDestinationHubName"];
          this.client_name = this.shipmenarr["clientname"];
          this.isimage = this.shipmenarr["isImage"];
          this.isvideo = this.shipmenarr["isVideo"];
          this.islastbagoutavailable = this.shipmenarr["islastbagoutavailable"];

          this.selectData()
          }
          else {
            this.$alertify.error(result.data.message);
            this.resetForm()
          }
        this.searchLoading = false;

        },
          (error) => {
            console.error(error);
          this.searchLoading = false;
        });
    },

    onFileChange(e) {
      this.attachment = e.target.files[0];
      this.FileSelected = this.attachment;
      this.FileSelected = null;

    },
    uploadFile() {
      if (!this.attachment) {
        this.$alertify.error("Please choose an image");
        return;
      }

      const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
      if (!allowedTypes.includes(this.attachment.type)) {
        this.$alertify.error("Please upload only allowed file formats");
        return;
      }

      if (this.attachment.size > 614400) {
        this.$alertify.error("Please upload document less than 600KB");
        return;
      }

      if (this.imagesarr.length >= 3) {
        this.$alertify.error("Only three images allowed");
        return;
      }

      let status = (this.statuss !== undefined && this.statuss !== null) ? this.statuss : 0;
      this.isUploading = true
      let form = new FormData();
      form.append('file', this.attachment);
      form.append('shippingid', this.awbnumber);
      form.append('primaryKey', 123);
      form.append('status', status);
      
      let uploadedFileName = this.attachment.name;
      axios.post(`${apiUrl.api_url}uploadimage`, form,{ headers: { 'Content-Type': 'multipart/form-data' }})
        .then(result => {
          if (result.data.errorCode == 0) {
            this.imagesarr.push({ file: uploadedFileName, imgPath: result.data.data });
            this.displaytable = this.imagesarr.length > 0;
            this.$alertify.success("Image uploaded successfully");
          } else {
            this.$alertify.error(`Failed to upload image as : ${result.data.msg}`);
          }
          this.isUploading = false
          this.attachment = null;
          this.FileSelected = null;
        })
        .catch(err => {
          console.error(err);
          this.displaytable = false;
          this.$alertify.error(`Upload failed as : ${err}`);
          this.isUploading = false
          this.attachment = null;
          this.FileSelected = null;
        });
    },


    downloadImage(filePath) {
      this.imgData = filePath;
      this.showModal = true;
    },

    closeImage() {
      this.showModal = false;
    },

    deleteImage(i) {
      let fileName = this.imagesarr[i].file ? this.imagesarr[i].file : '';
      const currentdate = moment(new Date()).format("DD_MM_YYYY");

      this.input = ({
        key: `STD/${this.awbnumber}/${currentdate}_${fileName}`,
        file: fileName
      });



      axios({
        method: 'post',
        url: `${apiUrl.api_url}deleteimage`,
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((result) => {
        if (result.data.errorCode == 0) {
          if (i > -1) {
            this.imagesarr.splice(i, 1);
            this.$alertify.error(result.data.msg);
          }
        } else {
          console.error(result.data.data);
          this.$alertify.error(result.msg);
        }
      },
        (error) => {
          console.error(error);
        });
    },

    resetForm() {
      this.dropStatus = '';
      this.Status = '';
      this.vStatus = '';
      this.hub = '';
      this.product_desc = '';
      this.current_region_name = '';
      this.origin_hub_name = '';
      this.current_hub_name = '';
      this.destination_hub_name = '';
      this.octroi_MRP = '';
      this.client_name = '';
      this.SubStatus = '';
      this.dropSubStatus = '';
      this.description = '';
      this.awbnumber = '';
      this.disputstatus = '',
        this.isLoading = false;
      this.$validator.reset(); this.errors.clear();
      this.Searchdisable = '';
      this.imagesarr = [];
      this.videosArr = [];
      this.isimage = true;
      this.isvideo = true;
      this.islastbagoutavailable = false;
      this.attachment = null;
    },


    save() {
      let reason = (this.reasons && this.reasons.label) ? this.reasons.label : (this.dropStatus && this.dropStatus.label) ? this.dropStatus.label : null;
      let subreason = (this.subReasons && this.subReasons.label) ? this.subReasons.label : (this.dropSubStatus && this.dropSubStatus.label) ? this.dropSubStatus.label : null;
      if (!reason){
        this.$alertify.error("Please Provide Reason")
      }else if (!subreason){
        this.$alertify.error("Please Provide Sub-reason")
      }else if (!this.description) {
        this.$alertify.error("Please Fill Description")
      }
      else if (this.isimage && this.imagesarr.length <= 2) {
        this.$alertify.error("Please Upload Three images")
        //this.exportdis = 1;
      }else if (this.isvideo && this.videosArr.length < 1){
        this.$alertify.error("Please Upload one video")
      }
      else {
        let cid = this.shipmenarr.CurrentHubID
        var cid1 = cid.toString()
        if (this.dropStatus.id) {
          let sid = this.dropStatus.id
          var DisputeStatusCode = sid.toString()
        }
        if (this.dropSubStatus.id) {
          let sid1 = this.dropSubStatus.id
          var RTODisputeStatusCode = sid1.toString()
        }
        this.Searchdisable = 1;

        this.input = ({
          ShippingID: this.awbnumber,
          HubID: cid1,
          DisputeStatusCode: RTODisputeStatusCode?RTODisputeStatusCode:null,
          RTODisputeStatusCode: DisputeStatusCode?DisputeStatusCode:null,
          DisputeComment: this.description,
          DisputeStatusName: this.dropSubStatus.label,
          RTODisputeStatusName: this.dropStatus.label,
          DisputeType: this.disputstatus,
          LastModifiedBy: this.username,
          Reasons: reason,
          SubReasons: subreason,
          disputemarkedonhubid : this.disputemarkedonhubid,
          disputemarkedonhubname : this.disputemarkedonhubname,
          disputeSource : "Web",
          islastbagoutavailable : this.islastbagoutavailable
        });
        axios({
          method: 'post',
          url: apiUrl.api_url + 'MarkRTOInvesttigation',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }


        }).then(result => {
          //this.exportdis = 1;

          if (result.data.code == 200) {
            this.$alertify.success(result.data.message)

          }
          else {
            this.$alertify.error(result.data.message)

          }

        })

        this.resetForm();

      }//else
    },
    onVideoFileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        this.selectedFile = null;
        return;
      }
      if (file.size > this.maxSizeBytes) {
        this.$alertify.error("File is too large. Maximum allowed size is 20 MB.");
        this.selectedFile = null;
        this.$refs.fileInput.value = null;
        return;
      }
      const nameParts = file.name.split(".");
      const ext = nameParts.length > 1 ? nameParts.pop().toLowerCase() : "";
      if (!this.allowedExtensions.includes(ext)) {
        this.$alertify.error(`Invalid file type. Allowed: ${this.allowedExtensions.join(", ")}`);
        this.selectedFile = null;
        this.$refs.fileInput.value = null;
        return;
      }
      this.selectedFile = file;
    },

    async uploadVideoFile() {
      if (!this.selectedFile) {
        this.$alertify.error("Please choose a video first.");
        return;
      }
      if(this.videosArr > 1){
        this.$alertify.error("Only one images allowed");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append('shippingid', this.awbnumber);
      this.isVideoUploading = true;
      try {

        const resp = await axios.post(`${apiUrl.api_url}uploadvideo`, formData, {
          headers: {
            Accept: "application/json"
          }
        });
        if (resp && resp.data) {
          const body = resp.data;
          if (body.errorCode === 0 || body.status === true) {
            const uploadedUrl = body.data || (body.data && body.data.Location) || "";
            const uploadedName = this.selectedFile.name;
            this.videosArr.push({ file: uploadedName, vidPath: uploadedUrl });
            this.isVideoUploading = false;
            this.$alertify && this.$alertify.success ? this.$alertify.success("Video uploaded successfully") : null;
            // clear selection
            this.$refs.videoInput.value = null;
            this.selectedFile = null;
          } else {
            // server returned some error
            this.isVideoUploading = false;
            this.$alertify.error(`Failed to upload image as : ${body.msg}`)
          }
        } else {
          this.isVideoUploading = false;
          this.$alertify.error("Unexpected response from server");
        }
      } catch (err) {
        // already handled errors above
        this.isVideoUploading = false;
        console.error("Upload error:", err);
      } finally {
        this.isVideoUploading = false;
      }
    },
    viewVideo(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
    deleteImage(i) {
      let fileName = this.videosArr[i].file ? this.videosArr[i].file : '';
      const currentdate = moment(new Date()).format("DD_MM_YYYY");
      this.input = ({
        key: `STD/Dispute/${this.awbnumber}/Videos/${currentdate}_${fileName}`,
        file: fileName
      });
      axios({
        method: 'post',
        url: `${apiUrl.api_url}deleteimage`,
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((result) => {
        if (result.data.errorCode == 0) {
          if (i > -1) {
            this.videosArr.splice(i, 1);
            this.$alertify.error(result.data.msg);
          }
        } else {
          console.error(result.data.data);
          this.$alertify.error(result.msg);
        }
      },
        (error) => {
          console.error(error);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/markRTOInvestigation/markRTOInvestigation.component.js